import { useEffect, useState } from 'react';

/**
 * Subscribes to `window.matchMedia`. SSR-safe: false until mounted.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const m = window.matchMedia(query);
    const set = () => setMatches(m.matches);
    set();
    m.addEventListener('change', set);
    return () => m.removeEventListener('change', set);
  }, [query]);

  return matches;
}
